import store from "@/store";

export const mapBaseLayers = (allFlag, config) => {
  config = config || store.getters.getMapConfig;
  // 天地图
  const vector_map = L.tileLayer.chinaProvider("TianDiTu.Satellite.Map", {
    tileSize: 256,
    key: "dec311e3d0bc3946b88d7116de7882ab",
    maxZoom: config.maxZoom,
    minZoom: config.minZoom,
  });
  //天地图标注
  const vector_annotion = L.tileLayer.chinaProvider(
    "TianDiTu.Satellite.Annotion",
    {
      tileSize: 256,
      key: "dec311e3d0bc3946b88d7116de7882ab",
      maxZoom: config.maxZoom,
      minZoom: config.minZoom,
    }
  );
  const vector_Group = L.layerGroup([vector_map, vector_annotion]);
  const Satellite_Streets = L.tileLayer('https://geoserver.mizarvision.com/map/satellite/{z}/{x}/{y}');
  const dark_map = L.tileLayer('https://geoserver.mizarvision.com/map/dark/{z}/{x}/{y}');

  const defaultMapURL = __IS__OFFLINE__ ? 'http://21.145.208.119:9312/map/osm_map/{z}/{x}/{y}.png' : 'https://geoserver.mizarvision.com/map/tf/{z}/{x}/{y}';
  const defaultMap = new L.tileLayer(defaultMapURL, {});

  if (!allFlag) {
    return Satellite_Streets;
  }
  let returnTileLayer;
  if (__IS__OFFLINE__) {
    returnTileLayer = {
      "自适应卫星底图": defaultMap,
    }
  } else {
    returnTileLayer = {
      "自适应卫星底图": defaultMap,
      "高清卫星地图": Satellite_Streets,
      "天地图": vector_Group,
    }
  }
  return returnTileLayer
}
